<template>
    <div id="how-it-works-suppliers">
        <!--=====================================-->
        <!--=      About  Quality Area Start    =-->
        <!--=====================================-->
        <section class="section section-padding bg-color-light-gray mb--50 sunflower-supplier">
            <div class="container">
                <div class="section-heading heading-light-left mb--100">
                    <span class="subtitle primary">¿Cómo funciona?</span>
                    <h2 class="font-weight-100">Pasos a <span class="bold">seguir</span>.</h2>
                </div>
                <div class="row justify-content-center">
                    <div class="col-sm-6 col-md-4 col-lg-4">
                        <div class="about-quality active">
                            <div class="bullet cursor-icon" :style="`background-image: url(${img1});`"></div>
                            <h4 class="title black bold">1. Crea tu cuenta</h4>
                            <p class="black h6 w-75">
                                Registrate como Instalador 
                                desde <a href="#" class="rg-a">aquí</a> y tendrás 
                                acceso a la plataforma 
                                digital para ingresar 
                                solicitudes.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 col-lg-4">
                        <div class="about-quality">
                            <div class="bullet percentage" :style="`background-image: url(${img5});`"></div>
                            <h4 class="title black bold">2. Simula</h4>
                            <p class="black h6 w-75">
                                Sácale jugo al simulador 
                                para armar la propuesta 
                                que se adapte a tu cliente.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 col-lg-4">
                        <div class="about-quality">
                            <div class="bullet paper" :style="`background-image: url(${img4});`"></div>
                            <h4 class="title black bold">3. Solicita</h4>
                            <p class="black h6 w-75">
                                Ingresa y completa 
                                una solicitud, nuestro equipo 
                                de revisión la analizará y te dará 
                                respuesta en 48 horas o menos.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 col-lg-4">
                        <div class="about-quality">
                            <div class="bullet card-icon" :style="`background-image: url(${img3});`"></div>
                            <h4 class="title black bold">4. Fondea</h4>
                            <p class="black h6 w-75">
                                La comunidad 
                                de RedGirasol se encargará 
                                de reunir el dinero necesario.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 col-lg-4">
                        <div class="about-quality">
                            <div class="bullet card-icon" :style="`background-image: url(${img2});`"></div>
                            <h4 class="title black bold">5. Ponlo a trabajar</h4>
                            <p class="black h6 w-75">
                                Recibe el anticipo para comenzar con el proyecto.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <Requirements />
        <Teams /> -->
    </div>
</template>

<script>
export default {
    name: "HowItWorks",
    components: {
    },
    data() {
        return {
            img1: "https://cdn.redgirasol.com/nuevo_portal/icons/cursor-icon.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/icons/sunflower-icon.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/icons/coin-icon.png",
            img4: "https://cdn.redgirasol.com/nuevo_portal/icons/paper-icon.png",
            img5: "https://cdn.redgirasol.com/nuevo_portal/icons/percentage-icon.png",
        }
    }
}

</script>

<style scoped>

.p-width {
    width: 15rem !important;
}

.bullet {
    background-repeat: no-repeat;
    background-size: 6.5rem;
    width: 7rem !important;
    height: 7rem !important;
    /* background-position-x: 1rem; */
}

.bullet.cursor-icon {
    background-size: 4.5rem !important;
    background-position-x: 1rem !important;
}

.bullet.card-icon {
    border-radius: 0 !important;
    background-position-y: center;
    background-position-x: center;
}

.percentage {
    background-size: 6rem;
    width: 7rem;
    height: 7rem;
    background-position-y: center;
}
.paper {
    width: 7rem;
    height: 7rem;
    background-position-x: center;
    background-size: 4rem;
    background-position-y: bottom;
}

.sunflower-supplier {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/extras/banner-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
}

@media only screen and (max-width: 575px) {
    .sunflower-supplier {
        background-image: none;
    }
}

</style>